export const toFixedValue = (data: any, decimals?: number) => {
	if (typeof data !== 'undefined' && data !== null) {
		return data.toFixed?.(decimals ? decimals : 2)
	}
	return ''
}
